import {
  AnyAction,
  createListenerMiddleware,
  Dispatch,
  ListenerEffectAPI,
  TypedStartListening,
} from '@reduxjs/toolkit';

import type { RootState } from '../../types';
import { logException, logError } from '../../utils/basics';

/**
 * Runs the side effects that react to actions (the replacement for the former saga watchers).
 * Listeners are registered with `startAppListening`, co-located with their module.
 */
const listenerMiddleware = createListenerMiddleware({
  // This handler gets the uncaught errors from listeners (same reporting as the saga middleware).
  onError(error, errorInfo) {
    logError(error);
    logError(errorInfo);
    logException((error as Error)?.message, errorInfo as unknown as Record<string, unknown>);
  },
});

/** The store's dispatch: plain redux, no thunks. */
export type AppDispatch = Dispatch<AnyAction>;

/** What a listener effect gets: `getState()` is the RootState, `take` resolves with the matched action. */
export type AppListenerApi = ListenerEffectAPI<RootState, AppDispatch>;

/** `startListening`, typed with the app's state and dispatch: effects need no casts. */
export const startAppListening = listenerMiddleware.startListening as TypedStartListening<RootState, AppDispatch>;

export default listenerMiddleware;
